import {
  ChangeDetectionStrategy,
  Component,
  Input,
  inject,
} from '@angular/core';
import {
  ControlContainer,
  FormGroup,
  ReactiveFormsModule,
} from '@angular/forms';
import { ServiceDataFields } from '@app/modules/service-data/components/service-data/service-data-form/field-sets/service-data-fields.enum';
import { TranslateModule } from '@ngx-translate/core';
import { ValidationErrorComponent } from '@shared/components/validation-error/validation-error.component';
import { InputValidationStatusDirective } from '@shared/directives/input-validation-status.directive';
import { controlContainerProvider } from '@shared/helpers';

@Component({
  selector: 'app-service-data-form-birth-information',
  imports: [
    ValidationErrorComponent,
    InputValidationStatusDirective,
    TranslateModule,
    ReactiveFormsModule,
  ],
  templateUrl: './service-data-form-birth-information.component.html',
  viewProviders: [controlContainerProvider],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ServiceDataFormBirthInformationComponent {
  private controlContainer = inject(ControlContainer);

  @Input({ required: true }) fieldSet: string[];
  protected get form() {
    return this.controlContainer.control as FormGroup;
  }

  protected readonly ServiceDataFields = ServiceDataFields;
}
